import InspectionChartsContainer from 'components/organisms/InspectionChartsContainer';
import InspectionChecklistGridContainer from 'components/organisms/InspectionChecklistGridContainer';
import React from 'react';
import FilterProvider from 'providers/Filter';
import InspectionChecklistTopContainer from 'components/organisms/InspectionChecklistTopContainer';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

const InspectionChecklistPresentation = () => {
  const [updatedAt, setUpdatedAt] = React.useState<Date | null>(null);
  const initialState = React.useMemo(
    () => ({
      plan: [{ label: dayjs().year().toString(), value: dayjs().year() }],
      week: [{ label: dayjs().isoWeek().toString(), value: dayjs().isoWeek() }],
      initialDate: [
        {
          label: dayjs().startOf('month'),
          value: dayjs().startOf('month').toISOString(),
        },
      ],
      finalDate: [
        {
          label: dayjs().endOf('month'),
          value: dayjs().endOf('month').toISOString(),
        },
      ],
    }),
    [],
  );

  return (
    <>
      <FilterProvider initialState={initialState}>
        <InspectionChecklistTopContainer updatedAt={updatedAt} />
        <InspectionChartsContainer updatedAt={updatedAt} />
        <InspectionChecklistGridContainer setUpdatedAt={setUpdatedAt} />
      </FilterProvider>
    </>
  );
};

export default InspectionChecklistPresentation;
